var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "casino-group-container casino-user-game-section-container"
    },
    [
      _c("casino-tabs", {
        attrs: { section: "userSection" },
        on: { tabChanged: _vm.onTabChange }
      }),
      _vm._v(" "),
      !_vm.data || _vm.data.games.length === 0
        ? _c("div", { staticClass: "no-games-in-list" }, [
            _vm._v(_vm._s(_vm.$t("Casino.No.Games")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.data && _vm.data.games && _vm.data.games.length > 0
        ? _c(
            "div",
            {
              staticClass: "slider-container",
              attrs: {
                "data-gid": _vm.dataId,
                id: "slider-container-" + _vm.dataId
              }
            },
            [
              _c("div", { staticClass: "group-header" }, [
                _vm.showHideSeeAll
                  ? _c(
                      "div",
                      { staticClass: "see-all" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "casino-page",
                                params: { slug: _vm.slugMap[_vm.section] }
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Casino.See.All")))]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("casino-slider", {
                key: _vm.componentKey,
                attrs: {
                  section: _vm.section,
                  group: _vm.groupSliderItemLimit,
                  gamesByGroup: _vm.filteredGames
                },
                on: { showHideSeeAll: _vm.updateSeeAllStatus }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d24dc7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d24dc7d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoUserGameSection.vue
// module id = null
// module chunks = 